import { Button } from "../Button";
import "./style.css";
import success from "../../../public/assets/success.png";
import clodeDown from "../../../public/assets/icon/clouddown.svg";
import homeIcon from '../../../public/assets/icon/homeIcon.svg';
import errorIcon from '../../../public/assets/icon/errorIcon.svg';
import { useContext, useEffect, useRef, useState } from "react";
import { completeShipment, downloadFile } from "../api";
import { useSSR } from "react-i18next";
import { formatPhoneNumber } from "../../utils";
import { quoteContext } from "../../context/quotesContext";
import { useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";

const { HomeLayout } = require("../HomeLayout");

const ShipmentStatus = () => {
    const [t, i18n] = useTranslation();
    const [error, setError] = useState(false);
    const {
        loading,
        setLoading,
        shipmentCompletedData,
        setShipmentCompletedData
    } = useContext(quoteContext);
    const query = new URLSearchParams(useLocation().search);

    const usaAddressId = query.get('usa_address_id');
    const coAddressId = query.get('co_address_id');
    const consolidatedId = query.get('consolidated_id');
    const stripe = query.get('stripe');
    const isZelle = query.get('iszelle');

    useEffect(() => {
        setLoading(true);
        const getCompleteShipment = async () => {
            try {
                const data = await completeShipment({
                    usa_address_id: usaAddressId,
                    co_address_id: coAddressId,
                    consolidated_id: consolidatedId,
                    stripe,
                    isZelle
                });

                if (data) {
                    setShipmentCompletedData(data);
                }
                setLoading(false);
            } catch (error) {
                setError(true);
                setLoading(false);
            }

        }
        getCompleteShipment();
    }, []);


    return (
        <HomeLayout>
            <div class="shipment-status-content">
                <div class="shipment-status-content-header">
                    {
                        (!loading || shipmentCompletedData || error) && (
                            <>
                                <div class={`icon-container ${error && 'error'}`} >
                                    {
                                        error ? <img src={errorIcon} /> : <img src={success} />
                                    }
                                </div>
                                <h2 class="">
                                    {(isZelle) && t('Pago pendiente')}
                                    {(error && !isZelle) ? t('there_are_an_error') : !isZelle && t('success_payment')}
                                </h2>
                            </>
                        )
                    }

                </div>
                {
                    loading && <>{t('loading')}</>
                }
                {
                    (!loading && shipmentCompletedData) && (
                        <>
                            <div class="summary">
                                <div className="summary-content">
                                    <h3 class="">{t('remitent')}</h3>
                                    <div className="data">
                                        <div className='icon'>
                                            <img src={homeIcon} />
                                        </div>
                                        <div>
                                            <p class="text-gray-700"><strong>{shipmentCompletedData.origin_address.street1}</strong></p>
                                            <p class="text-gray-700">{shipmentCompletedData.origin_address.city},{' '} {shipmentCompletedData.origin_address.state}, {' '}{shipmentCompletedData.origin_address.zip}</p>
                                            <p class="text-gray-700"> USA </p>
                                            <p class="text-gray-700"> {shipmentCompletedData.origin_address.name} {' '} {formatPhoneNumber(shipmentCompletedData.origin_address.phone)}</p>

                                        </div>
                                    </div>
                                </div>
                                <div className="divider">

                                </div>
                                <div className="summary-content">
                                    <h3 class="">{t('destination')}</h3>
                                    <div className="data">
                                        <div className='icon'>
                                            <img src={homeIcon} />
                                        </div>
                                        <div >

                                            <p class="text-gray-700"><strong>{shipmentCompletedData.destination_address.street1}</strong></p>
                                            <p class="text-gray-700">{shipmentCompletedData.destination_address.city},{' '} {shipmentCompletedData.destination_address.state}, {' '}{shipmentCompletedData.destination_address.zip}</p>
                                            <p class="text-gray-700"> COLOMBIA </p>
                                            <p class="text-gray-700"> {shipmentCompletedData.destination_address.name} {' '} {formatPhoneNumber(shipmentCompletedData.destination_address.phone)}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {
                                !isZelle && <div class="col-span-2 flex justify-between items-center">
                                    <div className="data downloand-container">
                                        <div className='icon'>
                                            <img src={clodeDown} />
                                        </div>
                                        <a href={shipmentCompletedData.label_url} target={'_blank'} class="text-blue-500 underline">guide.latam.shipping.pdf</a>
                                    </div>
                                    <div className="button-container">
                                        <Button
                                            className="animated-button"
                                        >
                                            <a href={shipmentCompletedData.label_url} target={'_blank'}
                                                style={{ color: 'white', textDecoration: 'none' }}>{t('download_guide')}</a>
                                        </Button>
                                    </div>

                                </div>
                            }


                            <div class="footer-status">
                                {
                                    isZelle && <>
                                        <h3>  {t('whats_next')}</h3>
                                        <h4>Zelle</h4>
                                        <p>
                                            <strong>
                                                {t('important_note')}

                                            </strong>
                                            {t('the_zelle_services')}<br />

                                        </p>
                                        <div>
                                            <center>
                                                <strong>{t('deliver_your_box_to')}</strong> {shipmentCompletedData.provider}<br />
                                                <img src={shipmentCompletedData.provider_img} height="100px" width="100px" /><br />
                                            </center>
                                        </div>

                                        <p>
                                            {t('zelle_indiacions_1')}  <br />

                                            arbelaezp@latamshipping.com<br />
                                            {t('just_reference')}<strong>{t('advanced_consulting_business')}</strong> <br />
                                            {t('advanced_consulting_business')}<br />
                                            {t('contact_by_whatsapp')}<a href="https://wa.me/13056991676"> +1 3056991676</a>  {t("in_order_to_send_guide")}<br />

                                            <strong>{t('last_step')} </strong>{t('delivery_your_box')}<br />
                                            <strong>{t('warning')} </strong>
                                            {t('box_that_are_more_than')}
                                            <br />
                                        </p>

                                    </>
                                }
                                {
                                    !isZelle && <>
                                        <h3> {t('whats_next')}</h3>
                                        <p>
                                            {t('print_your_guide')}<br />
                                        </p>
                                        <div>
                                            <center>
                                                <strong>{t('deliver_your_box_to')}</strong> {shipmentCompletedData.provider}<br />
                                                <img src={shipmentCompletedData.provider_img} height="100px" width="100px" /><br />
                                            </center>
                                        </div>
                                        <p> <strong>{t('warning')} </strong>{t('box_that_are_more_than')} <br /></p>
                                    </>
                                }

                            </div>
                        </>
                    )
                }

            </div>


        </HomeLayout>
    );
}

export { ShipmentStatus };
